import { render, staticRenderFns } from "./TeacherMian.vue?vue&type=template&id=65edbf01&scoped=true"
import script from "./TeacherMian.vue?vue&type=script&lang=js"
export * from "./TeacherMian.vue?vue&type=script&lang=js"
import style0 from "./TeacherMian.vue?vue&type=style&index=0&id=65edbf01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65edbf01",
  null
  
)

export default component.exports